<template>
  <div>
    <v-navigation-drawer
      v-model="showPopup"
      absolute
      temporary
      :right="$store.getters.languageGetter === '1'"
      @input="changeState"
    >
      <div class="pa-3 grey lighten-3 text-h5">
        <v-icon
          size="30px"
          class="me-2"
        >
          mdi-account-circle
        </v-icon>
        <router-link
          v-if="$store.state.user"
          :to="{name: 'UserDashboard'}"
        >
          {{ $store.state.user.email }}
        </router-link>
        <template v-else>
          <router-link
            to="/login"
            class="primary--text cursor-pointer"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              تسجيل دخول
            </template>
            <template v-else>
              Sign In
            </template>
          </router-link>
          <span
            class="grey--text mx-1"
          >or</span>
          <router-link
            to="/register"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              تسجيل
            </template>
            <template v-else>
              Register
            </template>
          </router-link>
        </template>
      </div>
      <v-list class="font-size-large">
        <template v-for="(item, i) in navs">
          <v-list-item
            v-if="item.nameEn === 'Products'"
            :key="item.name"
            class="pe-2"
            @click="showCateLevelOne = true;$emit('update:close')"
          >
            <v-list-item-content>
              <v-list-item-title>
                <template v-if="$store.getters.languageGetter === '1'">
                  قائمة المنتجات
                </template>
                <template v-else>
                  Products
                </template>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item
            v-else
            :key="item.name"
            link
            exact
            @click="navigateToUrl(item.url)"
          >
            <v-list-item-content>
              <v-list-item-title
                exact
              >
                {{ $store.getters.languageGetter === '1' ? item.name : item.nameEn }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider :key="i" />
        </template>
        <v-list-group
          no-action
          value="true"
        >
          <template v-slot:activator>
            <v-list-item-title class="font-medium text-h5">
              {{ $store.getters.languageGetter === '1' ? 'دولة' : 'Country' }}
            </v-list-item-title>
          </template>
          <v-list-item
            v-for="(item, i) in $store.state.webConfig.countryList"
            :key="i"
            class="pe-3"
            @click="setUsedCountry(item)"
          >
            <v-list-item-title>{{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}</v-list-item-title>
            <v-list-item-action v-if="$store.getters.countryGetter && item.id === $store.getters.countryGetter.id">
              <v-icon small>
                mdi-check
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-group>
        <v-list-group
          no-action
          value="true"
        >
          <template v-slot:activator>
            <v-list-item-title class="font-medium text-h5">
              {{ $store.getters.languageGetter === '1' ? 'اللغة' : 'Language' }}
            </v-list-item-title>
          </template>
          <v-list-item
            v-for="(item, i) in language"
            :key="i"
            class="pe-3"
            @click="setLanguage(item)"
          >
            <v-list-item-title>{{ $store.getters.languageGetter === '1' ? item.text : item.textEn }}</v-list-item-title>
            <v-list-item-action v-if="item.value === $store.getters.languageGetter">
              <v-icon small>
                mdi-check
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="showCateLevelOne"
      fixed
      temporary
    >
      <div
        class="pa-3 grey lighten-3 text-h5 d-flex align-center"
        @click="showCateLevelOne = false;show = true"
      >
        <v-icon size="24px">
          mdi-chevron-left
        </v-icon>
        <template v-if="$store.getters.languageGetter === '1'">
          قائمة المنتجات
        </template>
        <template v-else>
          Products
        </template>
      </div>
      <v-list class="font-size-large">
        <v-list-item-group>
          <v-list-item
            v-for="(item, i) in categories.data"
            :key="item.id"
            link
            class="pe-2"
            @click="getCateLevelTwo(item, i)"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon v-if="item.son">
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-divider />
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="showCateLevelTwo"
      fixed
      temporary
    >
      <div
        class="pa-3 grey lighten-3 text-h5 d-flex align-center"
        @click="showCateLevelTwo = false;showCateLevelOne = true;"
      >
        <v-icon size="24px">
          mdi-chevron-left
        </v-icon>
        {{ cateName }}
      </div>
      <v-list class="font-size-large">
        <v-list-item-group
          v-for="item in cateLevelTwo"
          :key="item.id"
        >
          <v-list-item
            @click="navigateToGoodsList(item)"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'NavbarMobile',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPopup: false,
      cate: '',
      cateName: '',
      cateIndex: 0,
      showCateLevelOne: false,
      showCateLevelTwo: false,
      navs: [
        {
          name: 'الصفحة الرئيسية',
          nameEn: 'Home',
          url: { name: 'Home' },
        },
        {
          name: 'معلومات عنا',
          nameEn: 'About Us',
          url: { name: 'AboutUs' },
        },
        {
          name: 'قائمة المنتجات',
          nameEn: 'Products',
          url: { name: 'GoodsList', query: { p: 1 } },
        },
        {
          name: 'منتج جديد',
          nameEn: 'New Arrivals',
          url: { name: 'GoodsList', query: { type: '2', target: 'newArrivals', p: 1 } },
        },
        {
          name: 'اترك رسالة',
          nameEn: 'Feedback',
          url: { name: 'Feedback' },
        },
        {
          name: 'معلومات الاتصال بالشركة',
          nameEn: 'Contact Us',
          url: { name: 'ContactUs' },
        },
      ],
      language: [
        {
          text: 'عربي',
          textEn: 'Arabic',
          value: '1',
        },
        {
          text: 'الإنجليزية',
          textEn: 'English',
          value: '2',
        },
      ],
    };
  },
  computed: {
    ...mapState(['categories']),
    cateLevelTwo() {
      return this.categories.data[this.cateIndex] ? this.categories.data[this.cateIndex].son : [];
    },
  },
  watch: {
    $route(to) {
      if (to.name === 'GoodsList' && to.query.type) {
        this.setActiveNav(+to.query.type);
      } else {
        this.setActiveNav(this.navs.findIndex((item) => item.url.name === to.name));
      }
    },
    show(newValue) {
      this.showPopup = newValue;
    },
    showPopup(newValue) {
      if (!newValue) {
        this.$emit('update:hidePop');
      }
    },
  },
  created() {
    if (this.$route.name === 'GoodsList' && this.$route.query.type) {
      this.setActiveNav(+this.$route.query.type);
    } else {
      const index = this.navs.findIndex((item) => this.$route.name === item.url.name);
      this.setActiveNav(index);
    }
    this.getGoodsCagegoriesAsync();
  },
  methods: {
    ...mapActions(['getGoodsCagegoriesAsync']),
    setActiveNav(index) {
      this.navIndex = index;
    },
    getCateLevelTwo(item, i) {
      if (item.son) {
        this.cateName = this.$store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn;
        this.cateIndex = i;
        this.showCateLevelTwo = true;
        this.showCateLevelOne = false;
      } else {
        this.navigateToGoodsList(item);
      }
    },
    navigateToGoodsList(item) {
      this.$store.commit('goods/RESET_GOODS_LIST');
      this.$router.push({
        name: 'GoodsList',
        query: {
          categoryId: item.id,
          categoryName: item.dnames,
          p: 1,
        },
      });
      this.showPopup = false;
    },
    setUsedCountry(country) {
      if (country.id) {
        localStorage.setItem('country', country.id);
      } else {
        localStorage.removeItem('country');
      }
      this.$store.commit('SET_USED_COUNTRY', country.id);
      this.showPopup = false;
    },
    setLanguage(item) {
      if (item.value === '1') {
        this.$vuetify.rtl = true;
        document.title = this.$store.state.webConfig.companyName;
      } else {
        this.$vuetify.rtl = false;
        document.title = this.$store.state.webConfig.companyNameEn;
      }
      this.$store.commit('SET_LANGUAGE', item);
      this.showPopup = false;
    },
    navigateToUrl(url) {
      this.$router.push(url);
      this.showPopup = false;
    },
    changeState(e) {
      if (!e) {
        this.$emit('update:close');
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
